exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.editarDialupSet .h2_title[data-v-4a882025] {\n  font-weight: normal;\n}\n#cardDivTV[data-v-4a882025] {\n  width: 100%;\n}\n", ""]);

// exports
